import { TextArea } from '@pms-digital/design-system';
import { useRef } from 'react';

export interface SetupImportPasteTabProps {
  value: string;
  /** `pasted` is true when the change comes from a paste, false when typed. */
  onChange: (text: string, pasted: boolean) => void;
}

const PLACEHOLDER =
  "Étape\tDriver\tLevier d'implication\t…\n1\tConfiance des artisans\t…\n\nCollez ici les cellules copiées depuis Excel";

/** « Coller des cellules » tab (board 02). */
export function SetupImportPasteTab({ value, onChange }: SetupImportPasteTabProps) {
  // Set on the paste event, read by the change event that follows it.
  const pastedRef = useRef(false);
  return (
    <div>
      <TextArea
        label={<span>Cellules copiées depuis Excel</span>}
        placeholder={PLACEHOLDER}
        value={value}
        spellCheck={false}
        onPaste={() => {
          pastedRef.current = true;
        }}
        onChange={(event) => {
          const pasted = pastedRef.current;
          pastedRef.current = false;
          onChange(event.target.value, pasted);
        }}
      />
      <p className="mt-2 text-caption text-gray-500">
        L'aperçu apparaît dès que le collage contient une ligne d'en-têtes reconnue.
      </p>
    </div>
  );
}
